import n from "./td-longtail-vue-components147.js";
/* empty css                              */
import r from "./td-longtail-vue-components98.js";
var a = function() {
  var t = this, e = t._self._c, s = t._self._setupProxy;
  return e("div", { staticClass: "badge", class: s.containerClasses, style: s.styles }, [e("div", { staticClass: "badge__content" }, [t._t("default", function() {
    return [t.text ? e("span", { domProps: { innerHTML: t._s(t.text) } }) : t._e()];
  })], 2)]);
}, _ = [], o = /* @__PURE__ */ r(
  n,
  a,
  _,
  !1,
  null,
  "4024d33c"
);
const f = o.exports;
export {
  f as default
};
